export default (e, callback) => {
  try {
    e.currentTarget.value = e.currentTarget.value.replace(/[^0-9]+/g, '')
    // eslint-disable-next-line no-empty
  } catch (error) {}

  callback(e)
}
